import React from "react";
import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import SpecialistStatisticsRoutes from "./SpecialistStatisticsRoutes";

const SpecialistStatisticsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Statistics",
      page: "Statistics Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <SpecialistStatisticsRoutes />
      </Track>
    </div>
  );
};

export default SpecialistStatisticsScreen;
